import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import api from "@/api";
import HomePage from "@/pages/HomePage";
import ProductPage from "@/pages/ProductPage";
import AboutPage from "@/pages/AboutPage";
import ForBuildersPage from "@/pages/ForBuildersPage";
import ForArchitectsPage from "@/pages/ForArchitectsPage";
import LocationPage from "@/pages/LocationPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.startsWith('/admin')) {
      api.post('/track', {
        page: location.pathname,
        referrer: document.referrer || '',
        screen_width: window.innerWidth
      }).catch(() => {});
    }
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <PageTracker />
          <Routes>
            {/* Public EN Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/for-builders" element={<ForBuildersPage />} />
            <Route path="/for-architects" element={<ForArchitectsPage />} />
            <Route path="/locations/:city" element={<LocationPage />} />

            {/* Public ES Routes */}
            <Route path="/es" element={<HomePage />} />
            <Route path="/es/products/:slug" element={<ProductPage />} />
            <Route path="/es/about" element={<AboutPage />} />
            <Route path="/es/for-builders" element={<ForBuildersPage />} />
            <Route path="/es/for-architects" element={<ForArchitectsPage />} />
            <Route path="/es/locations/:city" element={<LocationPage />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
